import React, { useCallback, useState } from 'react'
import { Card } from 'react-bootstrap'
const ScrollableImage = (props) => {
  const { onClick } = props
  const [objectPosition, setObjectPosition] = useState('')
  const [hasDragged, setHasDragged] = useState(false)

  const handleMouseDown = (e) => {
    setHasDragged(false)
    e.target.style.cursor = 'grabbing'
    e.target.addEventListener('mousemove', handleMouseMove)
  }

  const handleMouseUp = (e) => {
    e.target.style.cursor = 'pointer'
    e.target.removeEventListener('mousemove', handleMouseMove)
    setObjectPosition('')
  }

  const handleMouseMove = useCallback((e) => {
    e.preventDefault()
    setHasDragged(true)
    var rect = e.target.getBoundingClientRect();
    var x = e.clientX - rect.left; //x position within the element.
    var y = e.clientY - rect.top;  //y position within the element.
    const height = e.target.height
    const width = e.target.width
    const hPercent = 100 - Math.round(y / height * 100)
    const wPercent = 100 - Math.round(x / width * 100)
    setObjectPosition(`${wPercent}% ${hPercent}% `)
  }, [])


  const handleClick = (e) => {
    if (hasDragged) {
      e.stopPropagation()
    } else {
      onClick(e)
    }
  }

  return (
    <Card.Img
      {...props}
      style={{ objectFit: 'none', objectPosition: objectPosition }}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      draggable={false}
      onClick={handleClick}
    />
  )
}
export default ScrollableImage